import { Box, Grid, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import LineItemTab from './plannerTab/LineItemTab'
import BasicDetailTab from './plannerTab/BasicDetailTab'
import TemplateTaxTab from './plannerTab/TemplateTaxTab'
import SummaryTab from './plannerTab/SummaryTab'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './index.module.scss'

const PlannerInvoiceStepper = ({ onSubmit }) => {
	const [value, setValue] = useState(0)
	const isSmallScreen = useMediaQuery('(max-width:991px)')

	const options = [
		{ value: 'completed', label: 'Completed' },
		{ value: 'charged', label: 'Charged' },
		{ value: 'pending', label: 'Pending' },
	]
	const handleChange = (event, newValue) => {
		setValue(newValue)
	}

	const handleNext = () => {
		if (value < 3) {
			setValue(value + 1)
		} else {
			// Handle Create Invoice submission
			console.log('Create Invoice')
			if (onSubmit) {
				onSubmit()
			}
		}
	}

	const handlePrev = () => {
		if (value > 0) {
			setValue(value - 1)
		}
	}

	function CustomTabPanel(props) {
		const { children, value, index, ...other } = props

		return (
			<div
				role="tabpanel"
				hidden={value !== index}
				id={`simple-tabpanel-${index}`}
				aria-labelledby={`simple-tab-${index}`}
				{...other}
			>
				{value === index && <Box>{children}</Box>}
			</div>
		)
	}
	const mainTabStyle = {
		'& .MuiTabs-scrollButtons.Mui-disabled': {
			opacity: '0.3',
		},
		'&.MuiTabs-root': {
			minHeight: 'unset',
		},
		'& .MuiButtonBase-root': {
			padding: '11px 16px',
			minHeight: 'unset',
			fontSize: '14px',
			fontFamily: 'Inter',
			fontWeight: '500',
			color: '#313131',
			textTransform: 'capitalize',
			'&.Mui-selected': {
				color: '#7CA6BD',

				'& svg path': {
					stroke: '#7CA6BD',
				},
			},
		},
		'& .MuiTabs-indicator': {
			backgroundColor: '#7CA6BD',
		},
		'@media (max-width: 599px)': {
			'& .MuiButtonBase-root': {
				padding: '8px',
			},
		},
	}
	const [userDetails, setUserDetails] = useState({
		date: '',
	})
	return (
		<>
			<section className={styles.tabSection}>
				<Box sx={{ width: '100%' }} className={styles.tabs}>
					<Box sx={{ borderBottom: 1, borderColor: '#DFE4EB' }}>
						<Tabs
							value={value}
							onChange={handleChange}
							aria-label="basic tabs example"
							sx={mainTabStyle}
							variant={isSmallScreen ? 'scrollable' : 'standard'}
							scrollButtons={isSmallScreen ? 'auto' : false}
							allowScrollButtonsMobile={isSmallScreen}
						>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="BasicDetails">
											Basic Details
										</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="LineItems">
											Line Items
										</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="TemplateAndTax">
											Template & Tax
										</span>
									</div>
								}
							/>
							<Tab
								label={
									<div className={styles.tabItem}>
										<span data-cy="Summary">Summary</span>
									</div>
								}
							/>
						</Tabs>
					</Box>

					<div className={styles.tabContentWrp}>
						<Box
							sx={{ width: '100%', margin: '10px 0' }}
							className={styles.mainTabs}
						>
							<CustomTabPanel
								value={value}
								index={0}
								className={styles.content}
							>
								<form
									onSubmit={() => {}}
									className={styles.formWrp}
								>
									<BasicDetailTab
										userDetails={userDetails}
										setUserDetails={setUserDetails}
										options={options}
									/>
								</form>
							</CustomTabPanel>
							<CustomTabPanel
								value={value}
								index={1}
								className={styles.content}
							>
								<Grid container spacing={2}>
									<Grid size={{ xs: 12, sm: 12, md: 12 }}>
										<LineItemTab />
									</Grid>
								</Grid>
							</CustomTabPanel>
							<CustomTabPanel
								value={value}
								index={2}
								className={styles.content}
							>
								<Grid container spacing={2}>
									<Grid size={{ xs: 12, sm: 12, md: 12 }}>
										<TemplateTaxTab />
									</Grid>
								</Grid>
							</CustomTabPanel>
							<CustomTabPanel
								value={value}
								index={3}
								className={styles.content}
							>
								<Grid container spacing={2}>
									<Grid size={{ xs: 12, sm: 12, md: 12 }}>
										<SummaryTab />
									</Grid>
								</Grid>
							</CustomTabPanel>
						</Box>
					</div>
				</Box>
				<div className={styles.footerContent}>
					{value > 0 && (
						<ButtonCustom
							onClick={handlePrev}
							variant="outlined"
							size="lg"
						>
							Previous
						</ButtonCustom>
					)}
					<ButtonCustom
						variant="default"
						size="lg"
						onClick={handleNext}
					>
						{value === 3 ? 'Create Invoice' : 'Next'}
					</ButtonCustom>
				</div>
			</section>
		</>
	)
}

export default PlannerInvoiceStepper
